import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../api/Auth";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    if (!email || email.trim() === "") {
      setErrorMsg("Please enter your email address.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrorMsg("Valid email is required");
      return;
    }

  try {
    const res = await forgotPassword(email); // Use your API helper
    setSuccessMsg(res.message);
      navigate("/auth/verify-otp", { state: { email } });
  } catch (error) {
    setErrorMsg(error.response?.data?.message || "Something went wrong");
  }
};


  return (
    <Col lg="5" md="7">
      <Card className="bg-secondary shadow border-0">
        <CardBody className="px-lg-5 py-lg-5">
          <Form role="form" onSubmit={handleSubmit} noValidate>
            <h3 className="text-center mb-4">Forgot Password</h3>
            <FormGroup className="mb-3">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-email-83" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Enter your email"
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setErrorMsg("");
                  }}
                  required
                />
              </InputGroup>
            </FormGroup>
            <div className="text-center">
              <Button color="primary" type="submit">
                Send OTP
              </Button>
            </div>
            {successMsg && (
              <div className="text-success text-center mt-3">{successMsg}</div>
            )}
            {errorMsg && (
              <div className="text-danger text-center mt-3">{errorMsg}</div>
            )}
            <div className="text-center mt-3">
              <a
                href="#back"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/auth/login");
                }}
              >
                <small>Back to Login</small>
              </a>
            </div>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ForgotPassword;
